import axios from 'axios';

export async function get_masterdata(
  Customerdetails_endpoint,
  Warehousedetails_endpoint,
  Employeedetails_endpoint,
  Employerdetails_endpoint,
  Supplierdetails_endpoint,
  POnumbers_endpoint,
  // Commodity_endpoint,
  Consignmenttype_endpoint,
  // Invoicecurrency_endpoint,
  Transporter_endpoint,
  Equipment_endpoint,
  UOM_endpoint,
  Currency_endpoint, config
) {
  const [
    CustomerDetails,
    WarehouseDetails,
    EmployeeDetails,
    EmployerDetails,
    SupplierDetails,
    PONumbers,
    // CommodityDetails,
    ConsignmentType,
    // InvoiceCurrency,
    TransporterDetails,
    EquipmentDetails,
    UOMMasterList,
    CurrencyMasterList
  ] = await axios.all([
    axios.get(Customerdetails_endpoint, config),
    axios.get(Warehousedetails_endpoint, config),
    axios.get(Employeedetails_endpoint, config),
    axios.get(Employerdetails_endpoint, config),
    axios.get(Supplierdetails_endpoint, config),
    axios.get(POnumbers_endpoint, config),
    // axios.get(Commodity_endpoint, config),
    axios.get(Consignmenttype_endpoint, config),
    // axios.get(Invoicecurrency_endpoint),
    axios.get(Transporter_endpoint, config),
    axios.get(Equipment_endpoint, config),
    axios.get(UOM_endpoint, config),
    axios.get(Currency_endpoint, config),
  ]);

  return {
    CustomerDetails: CustomerDetails.data.Records,
    WarehouseDetails: WarehouseDetails.data.Records,
    EmployeeDetails: EmployeeDetails.data.Records,
    EmployerDetails: EmployerDetails.data.Records,
    SupplierDetails: SupplierDetails.data.Records,
    PONumbers: PONumbers.data.Records,
    // CommodityDetails: CommodityDetails.data.Records,
    ConsignmentType: ConsignmentType.data.Records,
    // InvoiceCurrency: InvoiceCurrency.data.Records,
    TransporterDetails: TransporterDetails.data.Records,
    EquipmentDetails: EquipmentDetails.data.Records,
    UOMMasterList: UOMMasterList.data.Records,
    CurrencyMasterList: CurrencyMasterList.data.Records,
  };
}
